var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc38(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "8.9958mm",
    height: "9.6546mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 8995.8 9654.6",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    fillRule: "nonzero",
    points: "8995.8,2063.7 8773.6,2063.7 8773.6,222.2 6932.1,222.2 6932.1,0 8995.8,0 "
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 5960.36 5797.16)",
    width: 222.2,
    height: 4024.3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 4677.35 4511.18)",
    width: 222.2,
    height: 1058.3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 355.146 190.806)",
    width: 222.2,
    height: 2614.1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 3716.1 5119.59)",
    width: 1084.8,
    height: 222.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#999999",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 5742.33 3096.89)",
    width: 4333.9,
    height: 222.2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    fillRule: "nonzero",
    points: "545,2063.7 322.8,2063.7 322.8,0 2386.5,0 2386.5,222.2 545,222.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    fillRule: "nonzero",
    points: "8995.8,8673 6932.1,8673 6932.1,8450.8 8773.6,8450.8 8773.6,6609.3 8995.8,6609.3 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M5127.6 9654.6l-3889.4 0 -1225 -4566.7 6281.2 0 -1166.8 4566.7zm-3704.2 -222.2l3545.5 0 1058.3 -4122.2 -5722.9 0 1119.1 4122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M6302.4 4553.5l-6302.4 0 762 -2071.7 4900.1 0 640.3 2071.7zm-5982.3 -222.3l5680.6 0 -502.7 -1624.5 -4579.9 0 -598 1624.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M4188.3 2706.7l-2071.7 0 0 -968.4 2066.4 0 5.3 968.4zm-1852 -224.9l1632.4 0 0 -529.2 -1624.5 0 -7.9 529.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    x: 3045.4,
    y: 6275.9,
    width: 222.2,
    height: 2632.6
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.978903 -0.204325 0.204325 0.978903 1573.45 6298.58)",
    width: 222.2,
    height: 2690.8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.204325 -0.978903 0.978903 0.204325 3967.93 8883.67)",
    width: 2690.8,
    height: 222.2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc38);
export default __webpack_public_path__ + "static/media/ic_3_8.f2db77f12c2f87004329a251f5174f7a.svg";
export { ForwardRef as ReactComponent };